<template>
  <div id="daily-grade" v-loading="loading" @click.stop="goodCheckArr=[]" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
    <div class="daily-filter">
      <!-- <div class="search">
        <input type="text" name="" id="" v-model="searchOrderId" placeholder="输入订单号查询">
        <button @click="searchByOrderId">
          <i class="iconfont icon-sousuo"></i>
        </button>
      </div> -->
      <span v-if="nowType=='DAY'" style="margin-right:15px;">
        <span class="filter-tit">结账员工:</span>
            <el-select v-model="empMobile"  placeholder="请选择" class="new-inp">
                <el-option
                :key="0"
                :label="'全部'"
                :value="''">
                </el-option>
                <el-option
                v-for="item in emps"
                :key="item.id"
                :label="item.name"
                :value="item.userName">
                </el-option>
            </el-select>
        </span>
      <div class="date-filter" v-if="nowType=='DAY'">
        <el-date-picker v-model="dateStr" type="date" ref='dateInput' value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="请选择选择日期">
        </el-date-picker>
        <i class="iconfont icon-jiantou" @click="$refs.dateInput.handleFocus()"></i>
      </div>
      <div class="time-range-filter" v-if="nowType=='TIME_RANGE'">
          <el-date-picker
          v-model="startTime"
          type="datetime"
          class="dateTime"
          default-time="00:00:00"
          placeholder="开始时间">
          </el-date-picker>
          <el-date-picker
          v-model="endTime"
          type="datetime"
          class="dateTime"
          default-time="23:59:59"
          placeholder="结束时间">
          </el-date-picker>
          <span >
        <span class="filter-tit">结账员工:</span>
            <el-select v-model="empMobile"  placeholder="请选择" class="new-inp">
                <el-option
                :key="0"
                :label="'全部'"
                :value="''">
                </el-option>
                <el-option
                v-for="item in emps"
                :key="item.id"
                :label="item.name"
                :value="item.userName">
                </el-option>
            </el-select>
        </span>
        <span class="quick-filter">
            <span :class="nowSelFilter=='today'?'active':''" @click.stop="filter('today')">今日</span>
            <span :class="nowSelFilter=='lastDay'?'active':''" @click.stop="filter('lastDay')">昨日</span>
            <span :class="nowSelFilter=='week'?'active':''" @click.stop="filter('week')">本周</span>
            <span :class="nowSelFilter=='lastWeek'?'active':''" @click.stop="filter('lastWeek')">上周</span>
            <span :class="nowSelFilter=='month'?'active':''" @click.stop="filter('month')">本月</span>
            <span :class="nowSelFilter=='lastMonth'?'active':''" @click.stop="filter('lastMonth')">上月</span>
        </span>
          <span>
            <span class="filter-tit">商品名:</span>
            <!-- <el-input type="text" style="width:150px;" v-model="productName" placeholder="请输入商品名" /> -->
                <div class="search" style="width:120px;" @click.stop="">
                    <input type="text" class="left" placeholder="请输入商品名" v-model="goods">
                    <i class="el-icon-search" @click="searchGoods"></i>
                    <ul class="details_search" @click.stop="" :style="{display:(goodCheckArr[0]?'block':'none')}">
                        <div class="leftIcon" :style="{top:(curGoodIdx*40+'px')}">
                            <div class="iconInner"></div>
                        </div>
                        <li v-for="item in goodCheckArr" @click="selSearchGood(item,'search')">
                            <div class="left name ellipsis" v-text="item.name" :title="item.name"></div>
                        </li>
                    </ul>
                </div>
          </span>
          <span class="types typesSearch" >
              <span type="button" @click="searchConfirm">查询</span>
          </span>
      </div>
      <!--  -->
      <!-- <div class="type-change" @click="nowType=='DAY'?nowType='TIME_RANGE':nowType='DAY'">
        <span>{{nowType=='DAY'?'按时间段查询':'按天查询'}}</span>
      </div> -->
      <!--  -->
    </div>
    
    <div class="in-and-out clearfix" v-if="showCharts">
      <div class="tit">收入退单</div>
      <div class="pie">
        <div class="income left">
          <div id="income-pie" class="pie-for-income left" v-show="showPie"></div>
          <div class="no-income" v-show="!showPie"><span>暂无任何收入数据</span></div>
          <!-- <div class="tip-info left">
                        <ul>
                            <li class="wechat">
                                <span class="tip-color"></span>
                                <span class="tip-cont">微信收入：{{gradeDataForPie.adminPayBill.wx}}元( {{gradeDataForPie.adminPayBill.wxCount+"笔"}} )</span>
                            </li>
                            <li class="ali">
                                <span class="tip-color"></span>
                                <span class="tip-cont">支付宝收入：{{gradeDataForPie.adminPayBill.ali}}元( {{gradeDataForPie.adminPayBill.alCount+"笔"}} )</span>
                            </li>
                            <li class="cash">
                                <span class="tip-color"></span>
                                <span class="tip-cont">现金收入：{{gradeDataForPie.adminPayBill.cash}}元( {{gradeDataForPie.adminPayBill.cashCount+"笔"}} )</span>
                            </li>
                            <li class="yl">
                                <span class="tip-color"></span>
                                <span class="tip-cont">银联收入：{{gradeDataForPie.adminPayBill.yl}}元( {{gradeDataForPie.adminPayBill.ylCount+"笔"}} )</span>
                            </li>
                        </ul>
                    </div> -->
        </div>
        <div class="out left">
          <div id="out-pie" class="pie-for-out left"  v-show="showOutPie"></div>
          <div class="no-income" v-show="!showOutPie"><span>暂无任何退单数据</span></div>
          <!-- <div class="tip-info left">
            <ul>
              <li class="out-tip">
                <span class="tip-color"></span>
                <span class="tip-cont">退款：{{gradeDataForPie.refundTotalAmount | toFixedNum}}元</span>
              </li>
            </ul>
          </div> -->
        </div>
      </div>
    </div>
    <div class="in-and-out-list" :style="!showCharts?'margin-top:20px;':''" v-if="showList">
      <div class="tit" v-if="showCharts">收入退单</div>
      <table style="width:100%;">
        <tr style="width:100%;">
          <th style="width:3%;">序号</th>
          <th style="width:6%;">座号</th>
          <th style="width:13%;">时间</th>
          <th style="width:7%;">实收</th>
          <th style="width:7%;">应收</th>
          <th style="width:5%;">折扣</th>
          <th style="width:4%;">抹零</th>
          <th style="width:10%;">支付方式</th>
          <th style="width:6%;">结账员工</th>
          <th style="width:8%;">订单来源</th>
          <th style="width:25%;">订单号</th>
          <th style="width:6%;">详情</th>
        </tr>
      </table>
      <div class="list">
        <table style="width:100%;" v-if="gradeListData.length>0">
          <tr style="width:100%;" v-for="(item,index) in gradeListData" :key="index">
            <td style="width:3%;" class="index-count">
              <i v-if="item.total<0" class="iconfont icon-tui"></i>
              {{index+1+(currentPage-1)*pageSize}}
            </td>
            <td style="width:6%;">{{item.tableNo?item.tableNo:"无"}}</td>
            <template v-if="item.amount<0">
              <td style="width:13%;" v-if="!isSmallScreen">{{item.refundTime | dateForGradePage}}</td>
              <td style="width:13%;" v-if="isSmallScreen">
                <div>{{new Date(item.refundTime).Format("yyyy-MM-dd")}}</div>
                <div>{{new Date(item.refundTime).Format("hh:mm:ss")}}</div>
              </td>
            </template>
            <template v-else>
              <td style="width:13%;" v-if="!isSmallScreen">{{item.createTime | dateForGradePage}}</td>
              <td style="width:13%;" v-if="isSmallScreen">
                <div>{{new Date(item.createTime).Format("yyyy-MM-dd")}}</div>
                <div>{{new Date(item.createTime).Format("hh:mm:ss")}}</div>
              </td>
            </template>
            <td style="width:7%;" class="amount">{{item.amount}}</td>
            <td style="width:7%;" class="amount">{{item.total}}</td>
            <td style="width:5%;" class="amount">{{item.discount}}</td>
            <td style="width:4%;" class="amount">{{item.removeZero}}</td>
            <td style="width:10%;">{{payType[item.paymentChannel]}}</td>
            <td style="width:6%;">{{item.creatorName}}</td>
            <td style="width:8%;">{{sourceType[item.source]}}</td>
            <td style="width:25%;">
              {{item.orderId}}
              <div style="font-size:13px;color: #999;">(支付单号:{{ item.payOrderId }})</div>
            </td>
            <th style="width:6%;color:blue;cursor:pointer;" @click="showOrderDetail(item)">详情</th>
          </tr>
        </table>
        <div class="no-data" v-else>暂无数据</div>
      </div>
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="totalElements">
        </el-pagination>
      </div>
    </div>
    <div class="loading">

    </div>
    <el-dialog
      title="订单详情"
      :visible.sync="doShowOrderDetail"
      width="9%"
      >
      <div style="max-height:300px;overflow:hidden;overflow-y:scroll;">
        <table style="width:100%;">
          <tr>
            <th>名称</th>
            <th>数量</th>
            <th>金额</th>
            <th>会员名称</th>
            <th>会员号码</th>
          </tr>
          <tr style="width:100%;" v-for="(item,index) in orderDetailData" :key="index">
            <td style="text-align:center;padding:5px 0;">{{item.productName}}</td>
            <td style="text-align:center;padding:5px 0;">{{item.qty}}</td>
            <td style="text-align:center;padding:5px 0;">{{item.amount}}</td>
            <td style="text-align:center;padding:5px 0;">{{item.memberName?item.memberName:'无'}}</td>
            <td style="text-align:center;padding:5px 0;">{{item.mobile?item.mobile:'无'}}</td>
          </tr>
        </table>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="doShowOrderDetail = false">取 消</el-button>
        <el-button type="primary" @click="doShowOrderDetail = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import echarts from "echarts";

export default {
  name: "dailyGrade",
  props: ["curStoreId"],
  data() {
    return {
      curGoodIdx: 0, // 当前商品索引
      goods:"",
      goodCheckArr:[],
      showList:false,
      nowSelFilter:"today",
      isSmallScreen:false,
      emps:[],
      empMobile:"",
      // pickerOptionsForTimeRange:{
      //     disabledDate(time) {
          
      //        let date = (new Date(time));
      //     //    let dateStr = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
      //     //    let newDate = new Date(dateStr).getTime();
      //     //    let newDateForNextMonth = new Date(date.getFullYear(),(date.getMonth()+1),0).getTime();
      //     //    return time.getTime() < newDate || time.getTime() > newDateForNextMonth;
      //         let curDate = (new Date()).getTime();
      //         let three = 35 * 24 * 3600 * 1000;
      //         let threeDays = curDate - three;
      //         return time.getTime() > Date.now() || time.getTime() < threeDays;
      //     } 
      // },
      sourceType: { // 订单来源类型
				POS: "收银台",
				WEB: "电脑点单",
				EMPLOYEE: "店员宝",
				WEIXIN: "微信点单",
				CONSUMER: "消费者，微信",
				TAKEOUT: "三方外卖"
			},
      showOutPie:false,
      canClick:true,
      startTime:'',//按时间段查询的起始时间
      endTime:'',//按时间段查询的结束时间
      nowType:"TIME_RANGE",
      orderDetailData:[],
      doShowOrderDetail:false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      dateStr: new Date().Format("yyyy-MM-dd"),
      pieForIncome: null, //收入饼状图
      pieForOut: null, //支出饼状图
      currentPage: 1,
      pageSize: 10,
      gradeDataForPie: {
        adminPayBill: {
          ali: 0,
          cash: 0,
          returnTotal: 0,
          wx: 0
        },
        refundTotalAmount: 0, //退总款金额
        successTotalAmount: 0 //总收入
      }, //经营日报的数据
      gradeListData: [], //经营日报列表数据
      searchOrderId: "", //所搜索的订单id
      payType: {
        "CASH": "现金",
        "ALIPAY": "支付宝",
        "WECHATPAY": "微信",
        "UNIONPAY": "银联",
        "pay.weixin.micropay":"微信刷卡",
        "pay.wechat.micropay":"微信刷卡",
        "pay.alipay.micropay":"支付宝刷卡",
        "pay.jdpay.micropay":"京东刷卡",
        "pay.qq.micropay":"QQ钱包刷卡",
        "pay.shiming.micropay":"会员卡",
        "pay.unionpay.micropay":"银联支付",
        "pay.bestpay.micropay":"翼支付",
        "pay.weixin.native":"微信扫码",
        "pay.wechat.native":"微信扫码",
        "pay.alipay.native":"支付宝扫码",
        "ALIPAY_CASH":"支付宝线下",
        "WECHATPAY_CASH":"微信线下",
        "COUPON":"优惠券",
        "MEMBER":"会员",
        "pay.wechat.jspay":"微信网页支付",
        "pay.alipay.jspay":"支付宝网页支付",
      },
      totalElements: 0, //数据总条数
      loading: true,
      showPie:false,//在没有数据的情况下是否显示饼状图
      productName:undefined,
      showCharts:true,
      goodSearchBtn:true,
    };
  },
  watch: {
    dateStr(val) {
      console.log(new Date(val).Format("yyyy-MM-dd"));
      let nowDate = new Date(val).Format("yyyy-MM-dd");
      this.dateStr = nowDate;
      this.getData(0, nowDate,this.empMobile);
    },
    nowType(val){
      this.showPie = false;
      this.showOutPie = false;
      this.gradeListData = [];
      this.totalElements = 0;
      this.empMobile = "";
    },
    empMobile(val){
      if(this.nowType == "DAY"){
        this.getData(0, this.dateStr,val);
      }
    },
    goods : function(val){
        if(val){
            this.searchGoods(val,null)
        }else {
          this.goodCheckArr = [];
          this.goods = undefined;
          this.goodSearchBtn = true;
        }
    },
  },
  methods: {
    selSearchGood(item,boo){
      this.goods = item.name;
      // this.goodSearchBtn = false;
      setTimeout(()=>{
        this.goodCheckArr = [];
      },250)
    },
     // 商品检索
      searchGoods(val,id){
        if ( !this.goodSearchBtn ) {
            return;
        }
        this.goodSearchBtn = false;
        this.$http.get('products/stores-search?storeId='+(id?id:this.curStoreId)+'&stockEnabled=false'+'&q='+encodeURI(val)).then((res)=>{
            if(id){
                this.addGoodCheckArr = res.data;
                this.isAutoSearchBtn = false;
                setTimeout(()=>{
                    this.isAutoSearchBtn = true;
                },2000)
                setTimeout(()=>{
                    let that = this;
                    $('.add_details_search li').hover( function () {
                        that.addCurGoodIdx = $(this).index()-1;
                    }, function () {
                        that.addCurGoodIdx = 0;
                    })
                },0)
            }else {
                this.goodCheckArr = res.data;
                setTimeout(()=>{
                    let that = this;
                    $('.details_search li').hover( function () {
                        that.curGoodIdx = $(this).index()-1;
                    }, function () {
                        that.curGoodIdx = 0;
                    })
                },0)
            }
            this.goodSearchBtn = true;
        }).catch(()=>{
            this.goodSearchBtn = true;
        })
    },
      filter(type){
        let timeRangeArr = [];
        this.nowSelFilter = type;
        switch (type) {
            case "today":
                // this.yearMonth = new Date().Format("yyyy-MM");
                this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                // let year = new Date().Format("yyyy");
                // let month = new Date().Format("MM");
                this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                this.searchConfirm();
                break;
            case "lastDay":
                this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                this.startTime = `${new Date(new Date(this.startTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 00:00:00`;
                this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                this.endTime = `${new Date(new Date(this.endTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 23:59:59`;
                this.searchConfirm();
                break;
            case "week":
                timeRangeArr = this.$dateRange.getThisWeek();
                this.startTime = `${timeRangeArr[0]} 00:00:00`;
                this.endTime = `${timeRangeArr[1]} 23:59:59`;
                this.searchConfirm();
                break;
            case "lastWeek":
                timeRangeArr = this.$dateRange.getLastWeek();
                this.startTime = `${timeRangeArr[0]} 00:00:00`;
                this.endTime = `${timeRangeArr[1]} 23:59:59`;
                this.searchConfirm();
                break;
            case "month":
                timeRangeArr = this.$dateRange.getThisMonth();
                console.log(timeRangeArr)
                this.startTime = `${timeRangeArr[0]} 00:00:00`;
                this.endTime = `${timeRangeArr[1]} 23:59:59`;
                this.searchConfirm();
                break;
            case "lastMonth":
                timeRangeArr = this.$dateRange.getLastMonth();
                console.log(timeRangeArr)
                this.startTime = `${timeRangeArr[0]} 00:00:00`;
                this.endTime = `${timeRangeArr[1]} 23:59:59`;
                this.searchConfirm();
                break;
            default:
                break;
        }
    },
    // 搜索
    searchConfirm: function () {

        // 
        let timeStr = new Date(this.startTime).getTime() + "-" + new Date(this.endTime).getTime() + "-" + this.empMobile;
        let nowTime = new Date().getTime();
        if(!(this.$canClickSelect("dailyGradeTimeRange",timeStr,nowTime))){
            this.$message({
                message: '5秒内禁止重复查询相同数据',
                customClass: 'error'
            });
            return;
        }
        // 

        if(((new Date(this.endTime)).getTime() - (new Date(this.startTime)).getTime()) > 1000*60*60*24*35){
                this.$message({
                    message: '只能查询35天内的数据',
                    customClass: 'error'
                })
                return;
        }
        if(this.startTime!=='' && this.endTime!==''){
            if(new Date(this.startTime)>new Date(this.endTime)){
                this.$message({
                    message: '结束时间不能比开始时间小',
                    customClass: 'error'
                })
                return;
            }
            if(this.canClick){
              this.canClick = false;
              this.getData(0, this.dateStr,this.empMobile,"ARB", true);
            }
        }else{
            this.$message({
                message: '请选择查询时间段',
                customClass: 'error'
            })
            return;
        }
    },
    showOrderDetail(item){
      this.$http({
        url: "get-item",
        method: "GET",
        params: {
          orderId: item.orderId
        }
      }).then(res => {
        this.doShowOrderDetail = true;
        this.orderDetailData = res.data;
      });
    },
    //按订单查询
    searchByOrderId() {
      this.$http({
        url: "get-storeBill",
        method: "GET",
        params: {
          orderId: this.searchOrderId
        }
      }).then(res => {
        console.log(res);
        this.gradeListData = res.data.data;
        this.totalElements = 0;
      });
    },
    //分页方法
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      console.log(this.dateStr);
      if(this.nowType == "DAY"){
        this.getData(val - 1, this.dateStr,this.empMobile,"DAY", false);
      }else{
        if(this.startTime!=='' && this.endTime!==''){
            if(new Date(this.startTime)>new Date(this.endTime)){
                this.$message({
                    message: '结束时间不能比开始时间小',
                    customClass: 'error'
                })
                return;
            }
        }else{
            return;
        }
        this.getData(val - 1, this.dateStr,this.empMobile,"ARB", false);
      }
    },
    drawPieForIncome(data, incomeData) {
      if (this.pieForIncome) {
        // this.pieForIncome.dispose();
      }
      this.pieForIncome = echarts.init(document.getElementById("income-pie"));
      let legendData = [];
      for (let i = 0; i < incomeData.length; i++) {
        legendData.push(incomeData[i].name);
      }
      let option = {
        title: {
          text: `总收入:${Number(data.successTotalAmount - data.refundTotalAmount).toFixed(2)}( ${data.successCount - data.refundCount}笔)`,
          x: "left",
          padding: 15,
          textStyle: {
            color: "#000",
            fontSize: 16
          }
        },
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b} : {c} ({d}%)"
          formatter: "{a} <br/>{b} "
        },
        legend: {
          orient: "vertical",
          right:"20%",
          data: legendData,
          top: "middle",
          type: "scroll"
        },
        color: ["#55a8dc", "#6fcd58", "#e78d61", "#000000"],
        series: [
          {
            name: "收入来源",
            type: "pie",
            radius: "55%",
            center: ["35%", "50%"],
            label: {
              normal: {
                position: "inner",
                show: false
              }
            },
            data: incomeData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      setTimeout(() => {
        this.pieForIncome.setOption(option);
      }, 200);
    },
    drawPieForOut(data,outData) {
      if (this.pieForOut) {
        this.pieForOut.dispose();
      }
      this.pieForOut = echarts.init(document.getElementById("out-pie"));
      let legendData = [];
      for (let i = 0; i < outData.length; i++) {
        legendData.push(outData[i].name);
      }
      let option = {
        title: {
          text: `退单:${Number(data.refundTotalAmount).toFixed(2)}( ${data.refundCount}笔 )`,
          x: "left",
          padding: 15,
          textStyle: {
            color: "#000",
            fontSize: 16
          }
        },
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b} : {c} ({d}%)"
          formatter: "{a} <br/>{b} "
        },
        legend: {
          orient: "vertical",
          right:"20%",
          data: legendData,
          top: "middle",
          type: "scroll"
        },
        color: ["#37d6b7"],
        series: [
          {
            name: "退单",
            type: "pie",
            radius: "55%",
            center: ["35%", "50%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                position: "inner",
                show: false
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            // data: [{ value: data.refundTotalAmount, name: "退款" }]
            data: outData
          }
        ]
      };
      setTimeout(() => {
        this.pieForOut.setOption(option);
      }, 200);
    },
    formatData(data){
      let returnData = [];
          if (data.length) {
            this.showPie = true;
            // 提取信息
            for (let i = 0; i < data.length; i++) {
              let amountObj = {};
              amountObj.value = Number(data[i].amount).toFixed(2);
              amountObj.count = data[i].count;
              switch (data[i].channel) {
                // case "pay.weixin.micropay":
                //   amountObj.name = "微信刷卡";
                //   amountObj.itemStyle = { normal: { color: "#e29fbf" } };
                //   break;
                // case "pay.alipay.micropay":
                //   amountObj.name = "支付宝刷卡";
                //   amountObj.itemStyle = { normal: { color: "#d69947" } };
                //   break;
                // case "pay.jdpay.micropay":
                //   amountObj.name = "京东刷卡";
                //   amountObj.itemStyle = { normal: { color: "#d17c42" } };
                //   break;
                case "jdMicroPay":
                  amountObj.name = "京东刷卡";
                  amountObj.itemStyle = { normal: { color: "#d17c42" } };
                  break;
                // case "pay.qq.micropay":
                //   amountObj.name = "QQ钱包刷卡";
                //   amountObj.itemStyle = { normal: { color: "#b3c125" } };
                //   break;
                case "qqMicroPay":
                  amountObj.name = "QQ钱包刷卡";
                  amountObj.itemStyle = { normal: { color: "#b3c125" } };
                  break;
                // case "pay.shiming.micropay":
                //   amountObj.name = "会员卡";
                //   amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                //   break;
                case "smMicroPay":
                  amountObj.name = "会员卡";
                  amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                  break;
                // case "pay.unionpay.micropay":
                //   amountObj.name = "银联支付";
                //   amountObj.itemStyle = { normal: { color: "#ff9e9c" } };
                //   break;
                case "unionPay":
                  amountObj.name = "银联支付";
                  amountObj.itemStyle = { normal: { color: "#ff9e9c" } };
                  break;
                // case "pay.bestpay.micropay":
                //   amountObj.name = "翼支付";
                //   amountObj.itemStyle = { normal: { color: "#ea7f5e" } };
                //   break;
                case "wingPayAmount":
                  amountObj.name = "翼支付";
                  amountObj.itemStyle = { normal: { color: "#ea7f5e" } };
                  break;
                // case "pay.weixin.native":
                //   amountObj.name = "微信扫码";
                //   amountObj.itemStyle = { normal: { color: "#8ecc52" } };
                //   break;
                // case "pay.alipay.native":
                //   amountObj.name = "支付宝扫码";
                //   amountObj.itemStyle = { normal: { color: "#41bbd8" } };
                //   break;
                case "CASH":
                  amountObj.name = "现金";
                  amountObj.itemStyle = { normal: { color: "#3bbddb" } };
                  break;
                case "cashAmount":
                  amountObj.name = "现金";
                  amountObj.itemStyle = { normal: { color: "#3bbddb" } };
                  break;
                case "WECHATPAY":
                  amountObj.name = "微信";
                  amountObj.itemStyle = { normal: { color: "#51c332" } };
                  break;
                case "wechatAmount":
                  amountObj.name = "微信";
                  amountObj.itemStyle = { normal: { color: "#51c332" } };
                  break;
                case "ALIPAY":
                  amountObj.name = "支付宝";
                  amountObj.itemStyle = { normal: { color: "#d69947" } };
                  break;
                case "alipayAmount":
                  amountObj.name = "支付宝";
                  amountObj.itemStyle = { normal: { color: "#56abe4" } };
                  break;
                case "UNIONPAY":
                  amountObj.name = "银联";
                  amountObj.itemStyle = { normal: { color: "#ff9e9c" } };
                  break;
                case "ALIPAY_CASH":
                  amountObj.name = "支付宝线下";
                  amountObj.itemStyle = { normal: { color: "#d69947" } };
                  break;
                case "WECHATPAY_CASH":
                  amountObj.name = "微信线下";
                  amountObj.itemStyle = { normal: { color: "#51c332" } };
                  break;
                case "COUPON":
                  amountObj.name = "优惠券";
                  amountObj.itemStyle = { normal: { color: "#619ce2" } };
                  break;
                case "couponAmount":
                  amountObj.name = "优惠券";
                  amountObj.itemStyle = { normal: { color: "#619ce2" } };
                  break;
                case "MEMBER":
                  amountObj.name = "会员";
                  amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                  break;
                case "memberAmount":
                  amountObj.name = "会员";
                  amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                  break;
                case "memberRechargeAmount":
                  amountObj.name = "会员充值";
                  amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                  break;
                default:
                  break;
              }
              amountObj.name = `${amountObj.name}:${amountObj.value}元(${amountObj.count}笔)`;
              // amountObj[billInfo.amount[i][0]] =  billInfo.amount[i][1];
              returnData.push(amountObj);
            }
            console.log(returnData);
          }
          return returnData;
    },
    getEmps(){
      this.$http({
        url:"employees",
        params:{
          storeId:this.curStoreId,
          enabled:true,
        }
      }).then(res=>{
        this.emps = res.data;
      })
    },
    
    //获取数据
    getData(page, date, empMobile="",type="DAY",isUpdatePie = true) {
      let params;
      this.showList = false;
      if(type=="DAY"){
        params = {
          storeId: this.curStoreId,
          time: date,
          page: page,
          size: this.pageSize,
          source: "store",
          type,
          empMobile:empMobile?empMobile:null,
          productName:this.goods?this.goods.trim():undefined
        };
      }else{
        let begin = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
        let end = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
        params = {
          storeId: this.curStoreId,
          // time: date,
          page: page,
          size: this.pageSize,
          source: "store",
          type,
          begin,
          end,
          empMobile:empMobile?empMobile:null,
          productName:this.goods?this.goods.trim():undefined
        };
      }
      this.showCharts = true;
      if(params.productName){
        this.showCharts = false;
      }
      this.loading = true;
      this.$http({
        url: "get-storeBill",
        method: "GET",
        params
      }).then(res => {
        setTimeout(()=>{
          this.showList = true;
        },500)
        if (res.status === 200) {
          setTimeout(()=>{
            this.canClick = true;
          },500);
          console.log(res);
          this.gradeDataForPie = res.data;
          this.gradeListData = res.data.data;
          this.totalElements = res.data.totalElements;

          let data = res.data;
          let billInfo = JSON.parse(data.adminPayBill);
          let refundBillInfo = JSON.parse(data.adminRefundBill);
          if (billInfo.adminPayBill.length) {
            this.showPie = true;
            let incomeData = this.formatData(billInfo.adminPayBill);
            console.log(incomeData);
            if (isUpdatePie) {
              setTimeout(() => {
                this.drawPieForIncome(data, incomeData);
              }, 150);
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.showPie = false;
            if (this.pieForIncome) {
              this.pieForIncome.dispose();
            }
          }
          if (refundBillInfo.adminPayBill.length) {
            this.showOutPie = true;
            let outData = this.formatData(refundBillInfo.adminPayBill);
            if (isUpdatePie) {
              setTimeout(() => {
                this.drawPieForOut(data,outData);
                // this.drawPieForOut(this.gradeDataForPie);
              }, 150);
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.showOutPie = false;
            if (this.pieForOut) {
              this.pieForOut.dispose();
            }
          }
        }else if (res.status === 500) {
          this.loading = false;
          this.$message({
            message: "系统运行错误",
            customClass: "error",
            showClose: true
          });
        }
      }).catch(err=>{
        setTimeout(()=>{
          this.showList = true;
        },500)
      });
    }
  },
  mounted() {
    // 
    this.getData(0, this.dateStr);
    this.getEmps();
    if(document.body.clientWidth<1500){
      this.isSmallScreen = true;
    }
    this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
    let year = new Date().Format("yyyy");
    let month = new Date().Format("MM");
    this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
    
  },
  // activated(){
  //   // this.getData(0, this.dateStr);
  //   // this.getEmps();
  // }
};
</script>

<style lang="scss">
@import "./dailyGrade.scss";
</style>



// WEBPACK FOOTER //
// dailyGrade.vue?4c7ba3c9